import axios from 'axios'
import router from "@/router";
import { Message } from 'element-ui';

// 创建可一个新的axios对象（调整前）
//const request = axios.create({
    //baseURL: process.env.VUE_APP_BASEURL,   // 后端的接口地址  ip:port
    //timeout: 30000                          // 30s请求超时
//})
// 创建可一个新的axios对象（调整后）
// 生产环境使用相对路径 /api，会自动使用当前域名（不带端口号），通过 nginx 代理到后端
// 开发环境使用环境变量或默认值
const baseURL = process.env.NODE_ENV === 'production'
    ? '/api'
    : (process.env.VUE_APP_BASEURL || 'http://127.0.0.1:9090')

const request = axios.create({
    baseURL: baseURL,   // 后端的接口地址
    timeout: 30000                          // 30s请求超时
})


// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    // FormData 不设置 Content-Type，让浏览器自动添加 multipart boundary
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    let user = JSON.parse(localStorage.getItem("xm-user") || '{}')  // 获取缓存的用户信息
    config.headers['token'] = user.token  // 设置请求头

    return config
}   ,error => {
    console.error('request error: ' + error) // for debug
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;

        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        if (res.code === '401') {
            localStorage.removeItem('xm-user');
            const currentPath = router.currentRoute.path;
            if (currentPath !== '/front/home') {
                if (res.msg) {
                    Message.error(res.msg);
                }
                router.push('/login');
            }
        }
        return res;
    },
    error => {
        console.error('response error: ' + error) // for debug
        return Promise.reject(error)
    }
)


export default request